import React from "react";
import { useTranslation } from "react-i18next";
import "./easiestTool.scss";

function EasiestTool() {
  const {t} = useTranslation()

  return (
    <div className="container-easiest-tool">
      <div className="texts-easiest-tool">
        <h1>{t("interactive_dashboards.easiest_tool.title")}</h1>
        <p>{t("interactive_dashboards.easiest_tool.section_text_1")}</p>
        <p>{t("interactive_dashboards.easiest_tool.section_text_2")}</p>
      </div>
    </div>
  );
}

export default EasiestTool;
